export function validateEmail(email: string) {
	return String(email)
		.toLowerCase()
		.match(
			/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
		);
}

export function validatePhone(phone: string, isNotKorea: boolean) {
	if (isNotKorea) return true;

	return phone.length === 10 && phone.startsWith("10");

	// const patternPhone = new RegExp("1[016789]-[^0][0-9]{2,3}-[0-9]{3,4}");
	// if (patternPhone.test(phone)) {
	// 	return true;
	// }
	// return false;
}

export function validatePhone2(phone: string) {
	return phone.startsWith("010");
}

export function makePhoneNumber(value: string) {
	let result = value;
	if (result.includes("-")) result = result.replace(/-/gi, "");

	if (result.length === 11 && result.startsWith("010")) return result.slice(1);
	return result;
}

export function makePhoneNumberV2(value: string) {
	let result = value;
	if (result.includes("-")) result = result.replace(/-/gi, "");
	return result;
}
